import type { ReactNode } from 'react';

import { Box, Card, Heading, Page } from '@zillow/constellation-10';

import LeasesHeaderNav from '../LeasesHeaderNav';
import { ParticipantBreadcrumb } from '../Widgets/ParticipantBreadcrumb';
import { useIsInMobileWebView } from '../../utils/mobileHandoffFunctions';

type Props = {
  children?: ReactNode;
  rightSidebarContent: ReactNode;
  breadcrumbLink?: string;
  breadcrumbText?: string;
};

function ParticipantContainer({ children, rightSidebarContent, breadcrumbLink, breadcrumbText }: Props) {
  const inMobileWebView = useIsInMobileWebView();

  return (
    <LeasesHeaderNav>
      <Page.Root css={{ backgroundColor: 'bg.screen.neutral' }}>
        {breadcrumbLink && breadcrumbText && !inMobileWebView && (
          <Page.Breadcrumb>
            <ParticipantBreadcrumb breadcrumbLink={breadcrumbLink} breadcrumbText={breadcrumbText} />
          </Page.Breadcrumb>
        )}
        <Page.Header>
          <Heading level={1}>Leases</Heading>
        </Page.Header>
        <Page.Content>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'repeat(12, 1fr)',
              gap: 'tight',
              alignItems: 'start',
            }}
          >
            <Card elevated={false} tone="neutral" css={{ gridColumnEnd: { base: 'span 12', lg: 'span 8' } }}>
              {children}
            </Card>
            <Card elevated={false} tone="neutral" css={{ gridColumnEnd: { base: 'span 12', lg: 'span 4' } }}>
              {rightSidebarContent}
            </Card>
          </Box>
        </Page.Content>
      </Page.Root>
    </LeasesHeaderNav>
  );
}

export default ParticipantContainer;
